import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/pages/Dashboard";
import CompetitionSetup from "@/pages/CompetitionSetup";
import History from "@/pages/History";
import Layout from "@/components/Layout";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/history" replace />} />
            <Route path="setup" element={<CompetitionSetup />} />
            <Route path="setup/:competitionId" element={<CompetitionSetup />} />
            <Route path="competition/:competitionId" element={<Dashboard />} />
            <Route path="history" element={<History />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
